import React from 'react';
import Modal from './Modal';
import Button from './Buttons';

const AssessmentUnassignedModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Assessment Not Assigned" size="sm">
      <p className="text-gray-600 mb-4">
        This assessment has not been assigned to anyone. Please assign it to a user or yourself before performing the assessment.
      </p>
      <div className="flex justify-end">
        <Button onClick={onClose}>OK</Button>
      </div>
    </Modal>
  );
};

export default AssessmentUnassignedModal;
